import type { IconName as UIIconName } from '@civilgrid/ui/components';
import { IconButton } from '@civilgrid/ui/components';
import type { IconName } from '~/components2/Icon';

// Map client icon names to UI icon names where they differ
const toUIIcon = (icon: IconName): UIIconName => {
  if (icon === 'delete') return 'trash';
  if (icon === 'close') return 'cross2';
  return icon as UIIconName;
};

interface MultiButtonProps {
  icon: IconName;
  label: string;
  color?: string;
  variant?: 'secondary' | 'danger' | 'primary' | 'hollow';
  isDisabled?: boolean;
  onClick?: () => void;
}

export default function ({ icon, label, variant = 'secondary', isDisabled, onClick }: MultiButtonProps) {
  return (
    <div className="group flex w-fit items-center rounded-sm">
      <IconButton
        icon={toUIIcon(icon)}
        variant={variant}
        onClick={onClick}
        disabled={!!isDisabled}
        className="shrink-0 gap-0! py-[5px]"
      >
        <span className="ml-0 w-0 overflow-hidden whitespace-nowrap transition-all duration-200 group-hover:w-24 group-hover:ml-3">
          {label}
        </span>
      </IconButton>
    </div>
  );
}
